import React, { useEffect, Fragment, useRef } from 'react'
import PropTypes from 'prop-types'
import LoginForm from '../LoginForm'
import UnlockEstateAddress from '../UnlockEstateAddress'
import AddSearchAgent from '../AddSearchAgent'
import DownloadExpose from '../DownloadExpose'
import user from '../../shared/user'
import Modal from 'scripts/components/Modal'
import './styles.scss'
import Button from '../Button'
import UnlockOguloTour from '../UnlockOguloTour'
import globalData from '../../shared/globalData'

const { loggedIn, loginUrl, signupUrl, pages } = globalData

const LoginModal = ({
  isOpen,
  component,
  openModal,
  closeModal,
  vermarktungsart,
  unlockFormSubmitted,
}) => {
  const openerRef = useRef(null)
  const wasOpenRef = useRef(false)

  useEffect(() => {
    const url = new URL(location)
    const loggedOut = url.searchParams.get('logged_out')

    if (loggedOut !== null) {
      url.searchParams.delete('logged_out')
      history.replaceState(null, null, url)
      openModal('loggedOut')
    }
  }, [])

  useEffect(() => {
    if (isOpen && component === 'addSearchAgent') {
      openerRef.current =
        (typeof window !== 'undefined' && window.__ksk001SearchAgentOpener) ||
        document.activeElement
    }

    if (wasOpenRef.current && !isOpen) {
      const opener = openerRef.current
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (
            opener &&
            typeof opener.focus === 'function' &&
            opener.isConnected
          ) {
            opener.focus()
          }
          openerRef.current = null
          if (typeof window !== 'undefined') {
            window.__ksk001SearchAgentOpener = null
          }
        })
      })
    }

    wasOpenRef.current = isOpen
  }, [component, isOpen])

  const renderTitle = () => {
    if (['unlockEstateAddress', 'unlockOguloTour'].includes(component)) {
      if (loggedIn && user.isFilled && !unlockFormSubmitted) {
        return 'Wir benötigen noch Ihre Zustimmung'
      }
      if (unlockFormSubmitted) {
        return 'Objektadresse freigeschaltet'
      }
    }
    if (component === 'unlockEstateAddress') {
      return 'Objektadresse freischalten'
    }
    if (component === 'unlockOguloTour') {
      return 'Virtuellen Rundgang freischalten'
    }
    if (component === 'addSearchAgent') {
      return 'Suche speichern'
    }
    if (component === 'addToShortlist') {
      return 'Objekt merken'
    }
    if (component === 'downloadExpose') {
      return 'Exposé erneut anfordern'
    }
    if (component === 'downloadPdf') {
      return 'PDF downloaden'
    }
    if (component === 'loggedOut') {
      return 'Auf Wiedersehen'
    }
    if (component === 'directlyUnlock') {
      return 'Objektadresse freigeschaltet'
    }
    return 'Login'
  }

  const renderStatus = () => {
    if (component === 'unlockEstateAddress') {
      if (loggedIn && !user.isFilled) {
        return 'Das Anfordern des Exposés ist nicht möglich. Bitte vervollständigen Sie Ihr Profil.'
      } else if (!loggedIn) {
        return (
          <>
            Bitte <a href={loginUrl}>loggen Sie sich ein</a> oder legen einen{' '}
            <a href={signupUrl}>neuen Account</a> an.
          </>
        )
      }
    }

    if (component === 'unlockOguloTour') {
      if (loggedIn && !user.isFilled) {
        return 'Zum Aufruf des virtuellen Rundgangs vervollständigen Sie bitte Ihr Profil.'
      } else if (!loggedIn) {
        return (
          <>
            Vielen Dank für Ihr Interesse an unserem virtuellen Rundgang.
            <br />
            Diesen können wir Ihnen erst nach vorheriger Registrierung
            zugänglich machen. Haben Sie bereits einen Account, dann melden Sie
            sich{' '}
            <a href={loginUrl + '?open_login_modal=unlockOguloTour'}>
              hier
            </a>{' '}
            an. <br />
            Oder legen Sie sich{' '}
            <a href={signupUrl + '?open_login_modal=unlockOguloTour'}>
              hier einen neuen Account
            </a>{' '}
            an.
          </>
        )
      }
    }

    if (component === 'addSearchAgent') {
      if (loggedIn && !user.isFilled) {
        return 'Das Anlegen eines Suchagenten ist nicht möglich. Bitte vervollständigen Sie Ihr Profil.'
      } else if (!loggedIn) {
        return (
          <>
            Um Ihre Suche zu speichern{' '}
            <a href={loginUrl}>loggen Sie sich bitte ein</a> oder legen einen{' '}
            <a href={signupUrl}>neuen Account</a> an.
          </>
        )
      }
    }

    if (component === 'addToShortlist') {
      return (
        <>
          Bitte <a href={loginUrl}>loggen Sie sich ein</a> oder legen einen{' '}
          <a href={signupUrl}>neuen Account</a> an.
        </>
      )
    }

    if (component === 'loggedOut') {
      return (
        <>
          Sie sind abgemeldet. Wir freuen uns auf Ihren nächsten Besuch.
          <br />
          Ihr KSK-Immobilien Team.
        </>
      )
    }

    if (component === '' && loggedIn) {
      return <>Sie sind bereits eingeloggt.</>
    }

    if (component === 'directlyUnlock') {
      return (
        <div className={`dhsv_success_message`}>
          <p>{`Die Objektadresse wurde freigeschaltet. Zudem wird Ihnen in Kürze der Download-Link des Exposés per E-Mail zugesandt.`}</p>
        </div>
      )
    }

    return false
  }

  const renderComponent = () => {
    if (component === 'unlockEstateAddress') {
      if (user.isFilled) {
        return <UnlockEstateAddress />
      } else if (user) {
        return (
          <Button
            url={`${pages.user_profile.link}/profileinstellungen`}
            style="primary"
            icon
          >
            Zum Profil
          </Button>
        )
      }
      return ''
    }
    if (component === 'unlockOguloTour') {
      if (user.isFilled) {
        return <UnlockOguloTour />
      } else if (user) {
        return (
          <Button
            url={`${pages.user_profile.link}/profileinstellungen`}
            style="primary"
            icon
          >
            Zum Profil
          </Button>
        )
      }
      return ''
    }
    if (component === 'addSearchAgent') {
      if (user.isFilled) {
        return <AddSearchAgent vermarktungsart={vermarktungsart} />
      } else if (user) {
        return (
          <Button
            url={`${pages.user_profile.link}/profileinstellungen`}
            style="primary"
            icon
          >
            Zum Profil
          </Button>
        )
      }
      return ''
    }
    if (component === 'downloadExpose') {
      return <DownloadExpose />
    }
  }

  return (
    <Fragment>
      <Modal
        overlayClassName="dhsv_login_modal"
        isOpen={isOpen}
        onRequestClose={closeModal}
        title={renderTitle()}
        className={component}
      >
        {renderStatus() && (
          <div
            className="dhsv_login_modal_error"
            tabIndex="-1"
            autoFocus
            role="status"
            aria-live="polite"
          >
            {renderStatus()}
          </div>
        )}
        {!loggedIn && component !== 'unlockOguloTour' && <LoginForm />}
        {loggedIn && component && renderComponent()}
      </Modal>
    </Fragment>
  )
}

LoginModal.propTypes = {
  isOpen: PropTypes.bool,
  component: PropTypes.string,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  vermarktungsart: PropTypes.string,
  unlockFormSubmitted: PropTypes.bool,
}

export default LoginModal
